module.exports = __webpack_public_path__ + "img/35-dec.22f470c3.png";